(function () {
  'use strict';

  function enhanceComplementary(root) {
    if (!root || root.dataset.begodeEnhanced === 'true') return;

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-begode-complementary-list] > product-card-small'));
    if (!cards.length) return;

    var controls = root.querySelector('[data-begode-complementary-controls]');
    var previous = root.querySelector('[data-begode-complementary-previous]');
    var next = root.querySelector('[data-begode-complementary-next]');
    var more = root.querySelector('[data-begode-complementary-more]');
    var status = root.querySelector('[data-begode-complementary-status]');
    var start = 0;
    var expanded = false;

    root.dataset.begodeEnhanced = 'true';

    function getMode() {
      if (window.matchMedia('(max-width: 767px)').matches) return 'mobile';
      if (window.matchMedia('(max-width: 1067px)').matches) return 'tablet';
      return 'desktop';
    }

    function getPageSize(mode) {
      if (mode === 'desktop') return 2;
      if (mode === 'tablet') return 2;
      return 3;
    }

    function render() {
      var mode = getMode();
      var pageSize = getPageSize(mode);
      var visibleEnd;

      if (mode === 'mobile') {
        start = 0;
        visibleEnd = expanded ? cards.length : Math.min(pageSize, cards.length);
      } else {
        expanded = false;
        start = Math.min(start, Math.max(0, cards.length - pageSize));
        visibleEnd = Math.min(start + pageSize, cards.length);
      }

      cards.forEach(function (card, index) {
        card.hidden = index < start || index >= visibleEnd;
      });

      if (status) {
        status.textContent = cards.length > 1 ? (start + 1) + '\u2013' + visibleEnd + ' / ' + cards.length : '';
      }

      if (controls) controls.hidden = cards.length <= pageSize;
      if (previous) previous.disabled = mode === 'mobile' || start === 0;
      if (next) next.disabled = mode === 'mobile' || visibleEnd >= cards.length;
      if (more) {
        more.hidden = mode !== 'mobile' || cards.length <= pageSize;
        more.textContent = expanded ? more.dataset.fewer : more.dataset.more;
        more.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }
    }

    if (previous) {
      previous.addEventListener('click', function () {
        start = Math.max(0, start - getPageSize(getMode()));
        render();
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        start = Math.min(cards.length - 1, start + getPageSize(getMode()));
        render();
      });
    }

    if (more) {
      more.addEventListener('click', function () {
        expanded = !expanded;
        render();
      });
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(render, 120);
    });

    render();
  }

  function enhanceAll(scope) {
    (scope || document).querySelectorAll('[data-begode-complementary]').forEach(enhanceComplementary);
  }

  document.addEventListener('begode:recommendations:loaded', function (event) {
    enhanceComplementary(event.target);
  });

  document.addEventListener('shopify:section:load', function (event) {
    enhanceAll(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { enhanceAll(document); });
  } else {
    enhanceAll(document);
  }
})();
